import styled from 'styled-components';
import { Box } from '@/shared/ui/box/Box';

const OffersGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export { OffersGrid }